export default __webpack_public_path__ + "static/media/3B33AFC1-021B-48F1-A148-67EDCD0C6064_1_105_c.6056b1c9.jpeg";